(() => {
  customElements.whenDefined('matilde-cart').then(() => {
    const Cart = customElements.get('matilde-cart');
    if (!Cart || Cart.prototype.__matildePaidGroupingPatched) return;
    Cart.prototype.__matildePaidGroupingPatched = true;

    const originalConnectedCallback = Cart.prototype.connectedCallback;
    const originalRender = Cart.prototype.render;
    const originalHandleClick = Cart.prototype.handleClick;

    Cart.prototype.mcGetGroupedLines = function(item) {
      try {
        const lines = JSON.parse(item?.dataset.mcGroupedLines || '[]');
        if (Array.isArray(lines) && lines.length) return lines;
      } catch (_) {}
      return item ? [{ key: item.dataset.key, quantity: Number(item.dataset.quantity) || 0 }] : [];
    };

    Cart.prototype.mcParseMoney = function(text = '') {
      let value = String(text).replace(/\u00a0/g, '').replace(/[^\d,.\-]/g, '');
      if (!value) return 0;
      const comma = value.lastIndexOf(',');
      const dot = value.lastIndexOf('.');
      if (comma > dot) value = value.replace(/\./g, '').replace(',', '.');
      else if (dot > comma) value = value.replace(/,/g, '');
      else value = value.replace(',', '.');
      const amount = Number(value);
      return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
    };

    Cart.prototype.mcFormatMoney = function(cents) {
      try {
        if (window.theme?.Currency?.formatMoney) {
          return window.theme.Currency.formatMoney(cents, window.theme.settings?.moneyFormat);
        }
        if (window.Shopify?.formatMoney) {
          return window.Shopify.formatMoney(cents, window.theme?.settings?.moneyFormat);
        }
      } catch (_) {}
      const currency = window.Shopify?.currency?.active || 'NOK';
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-PT', {
        style: 'currency',
        currency
      }).format(Number(cents || 0) / 100);
    };

    Cart.prototype.mcGroupPaidDuplicates = function(content = this.content) {
      if (!content) return;

      const source = content.querySelector('[data-mc-lines]');
      if (!source) return;
      const cart = { items: JSON.parse(source.textContent) };
      if (!Array.isArray(cart.items)) return;

      const rows = new Map(
        [...content.querySelectorAll('.mc__item[data-key]')].map(row => [row.dataset.key, row])
      );
      const groups = new Map();

      for (const line of cart.items) {
        const row = rows.get(line.key);
        if (!row) continue;

        const lineRef = { key: line.key, quantity: Number(line.quantity) || 0 };
        row.dataset.mcGroupedLines = JSON.stringify([lineRef]);

        const strong = row.querySelector('.mc__prices > strong');
        const renderedFinalCents = Number(line.final_price);

        // A linha grátis fica SEMPRE separada. Só agrupamos linhas cujo valor
        // final visível no carrinho é superior a zero.
        const isFree = renderedFinalCents === 0;
        row.dataset.mcPromoFree = String(isFree);
        row.dataset.mcGroupedPaid = 'false';
        if (isFree) {
          row.querySelectorAll('[data-mc-quantity]').forEach(button => {
            const disabled = Number(button.dataset.mcQuantity) > 0;
            button.disabled = disabled;
            button.setAttribute('aria-disabled', String(disabled));
          });
          continue;
        }

        const visibleProperties = Object.entries(line.properties || {})
          .filter(([key, value]) => value != null && value !== '' && !String(key).startsWith('_'))
          .sort(([a], [b]) => a.localeCompare(b));

        const sellingPlanId =
          line.selling_plan_allocation?.selling_plan?.id ||
          line.selling_plan_allocation?.selling_plan?.name ||
          '';

        const groupKey = JSON.stringify([
          line.variant_id,
          sellingPlanId,
          visibleProperties
        ]);

        const strike = row.querySelector('.mc__prices > s');
        const finalCents = renderedFinalCents * Number(line.quantity);
        const compareCents = strike
          ? this.mcParseMoney(strike.textContent)
          : (Number(line.original_line_price) || finalCents);

        if (!groups.has(groupKey)) {
          groups.set(groupKey, {
            primary: row,
            duplicates: [],
            lines: [lineRef],
            quantity: Number(line.quantity) || 0,
            finalCents,
            compareCents
          });
          continue;
        }

        const group = groups.get(groupKey);
        group.duplicates.push(row);
        group.lines.push(lineRef);
        group.quantity += Number(line.quantity) || 0;
        group.finalCents += finalCents;
        group.compareCents += compareCents;
      }

      for (const group of groups.values()) {
        if (group.lines.length < 2) continue;

        const primary = group.primary;
        primary.dataset.mcGroupedLines = JSON.stringify(group.lines);
        primary.dataset.quantity = String(group.quantity);
        primary.dataset.mcGroupedPaid = 'true';

        const quantityValue = primary.querySelector('.mc__quantity span');
        if (quantityValue) quantityValue.textContent = String(group.quantity);

        const prices = primary.querySelector('.mc__prices');
        const strong = prices?.querySelector(':scope > strong');
        if (strong) strong.textContent = this.mcFormatMoney(group.finalCents);

        if (prices) {
          let strike = prices.querySelector(':scope > s');
          if (group.compareCents > group.finalCents) {
            if (!strike) {
              strike = document.createElement('s');
              prices.insertBefore(strike, strong || prices.firstChild);
            }
            strike.hidden = false;
            strike.textContent = this.mcFormatMoney(group.compareCents);
          } else if (strike) {
            strike.hidden = true;
          }
        }

        const save = primary.querySelector('.mc__save');
        if (save) {
          if (group.compareCents > group.finalCents) {
            const icon = save.querySelector('svg');
            [...save.childNodes].forEach(node => {
              if (node !== icon) node.remove();
            });
            save.append(document.createTextNode('Du sparer '));
            save.append(document.createTextNode(this.mcFormatMoney(Math.round((group.compareCents - group.finalCents) / group.quantity))));
            save.hidden = false;
          } else {
            save.hidden = true;
          }
        }

        group.duplicates.forEach(row => row.remove());
      }
      const items = content.querySelector('.mc__items');
      if (items) {
        const rows = [...items.querySelectorAll('.mc__item')];
        rows.filter(row => row.dataset.mcPromoFree !== 'true').forEach(row => items.append(row));
        rows.filter(row => row.dataset.mcPromoFree === 'true').forEach(row => items.append(row));
      }
    };

    Cart.prototype.connectedCallback = function(...args) {
      const result = originalConnectedCallback.apply(this, args);
      this.mcGroupPaidDuplicates();
      return result;
    };

    Cart.prototype.render = function(...args) {
      const result = originalRender.apply(this, args);
      return result;
    };

    Cart.prototype.handleClick = function(event) {
      const target = event.target.closest('button,a');
      const isQuantityAction = target?.hasAttribute('data-mc-quantity') || target?.hasAttribute('data-mc-remove');
      if (!isQuantityAction) return originalHandleClick.call(this, event);

      const item = target.closest('[data-key]');
      if (Number(target.dataset.mcQuantity) > 0 && item?.dataset.mcPromoFree === 'true') { event.preventDefault(); return; }
      event.preventDefault();
      this.queueQuantityChange(item, Number(target.dataset.mcQuantity) || 0, target.hasAttribute('data-mc-remove'));

    };

    document.querySelectorAll('matilde-cart').forEach(cart => {
      if (cart.initialized) cart.mcGroupPaidDuplicates();
    });
  });
})();
